import { createActions, createReducer } from 'reduxsauce'
import Immutable from 'seamless-immutable'
import _ from 'lodash'

export const INITIAL_STATE = Immutable({
  data: {},
  loading: false,
})

const { Types, Creators } = createActions({
  getSpecialDeals: null,

  setLoading: ['val'],
  setSpecialDeal: ['data'],

  deleteSpecialDeal: ['specialDealId'],
  saveSpecialDeal: ['data'],

  saveDealItem: ['specialDealId', 'data'],
  deleteDealItem: ['specialDealId', 'itemKey'],

  syncSpecialDeal: ['specialDealId'],
  unSyncSpecialDeal: null,
})

export const setSpecialDealReducer = (state, { data }) => state.set('data', data)

export const setLoadingReducer = (state, { val }) => state.set('loading', val)

export const deleteSpecialDealReducer = (state, { specialDealId }) =>
  state.set('data', _.omit(state.data, specialDealId))

export const saveSpecialDealReducer = (state, { data }) =>
  state.setIn(['data', data.key], data)

export const saveDealItemReducer = (state, { specialDealId, data }) =>
  state.setIn(['data', specialDealId, 'items'], {...(state.data[specialDealId].items || {}), ...data, })

export const deleteDealItemReducer = (state, { specialDealId, itemKey }) =>
  state.setIn(['data', specialDealId, 'items'], _.omit(state.data[specialDealId].items, itemKey))

export const specialDealReducer = createReducer(INITIAL_STATE, {
  [Types.SET_SPECIAL_DEAL]: setSpecialDealReducer,
  [Types.SET_LOADING]: setLoadingReducer,
  [Types.DELETE_SPECIAL_DEAL]: deleteSpecialDealReducer,
  [Types.SAVE_SPECIAL_DEAL]: saveSpecialDealReducer,
  [Types.SAVE_DEAL_ITEM]: saveDealItemReducer,
  [Types.DELETE_DEAL_ITEM]: deleteDealItemReducer,
})

export const SpecialDealTypes = Types
export default Creators


// WEBPACK FOOTER //
// ./src/reducers/specialDealReducer.js